import React from 'react';
import MensagemList from '../MensagemList';
import { useMensagens } from '../../hooks/useMensagens';
/**
 * Tab de mensagens do acompanhamento
 * Integra lista e formulário de mensagens
 */

const MensagensTab = ({
  acompanhamentoId,
  onRefresh
}) => {
  const {
    mensagens,
    loading,
    error,
    loadMensagens
  } = useMensagens(acompanhamentoId); // Callback para refresh quando uma nova mensagem é criada

  const handleMensagemSuccess = () => {
    loadMensagens();

    if (onRefresh) {
      onRefresh();
    }
  };

  if (error) {
    return <div style={{
      padding: '20px',
      textAlign: 'center'
    }}>
        <p style={{
        color: '#dc3545'
      }}>
          Erro ao carregar mensagens. Tente novamente.
        </p>
        <button onClick={loadMensagens} style={{
        marginTop: '10px'
      }}>
          Tentar novamente
        </button>
      </div>;
  }

  return <div>
      <MensagemList acompanhamentoId={acompanhamentoId} // Passar os dados do hook para evitar dupla requisição
    mensagens={mensagens} loading={loading} onSuccess={handleMensagemSuccess} />
    </div>;
};

export default MensagensTab;
